import { TrackingLink } from './TrackingLink';

export const ReturnTrackingLinkOrInfo = ({ item, selectedKey }) => {
  if (selectedKey === 'statusPageUrl') {
    return item?.statusPageUrl ? (
      <TrackingLink url={item.statusPageUrl} title={'Status Page Link'} />
    ) : (
      <span>N/A</span>
    );
  }

  const selectedReturnTrackingURL = item?.trackingURL;

  if (selectedReturnTrackingURL === 'n/a') {
    return <span>{selectedReturnTrackingURL}</span>;
  }

  if (selectedReturnTrackingURL) {
    return <TrackingLink url={selectedReturnTrackingURL} />;
  }

  const { trackingNumber, carrier } = item;

  if (trackingNumber) {
    return (
      <span>
        {carrier} {trackingNumber}
      </span>
    );
  }

  return <span>-</span>;
};
